import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=22b82080&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"
import style0 from "./Trades.vue?vue&type=style&index=0&id=22b82080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b82080",
  null
  
)

export default component.exports